import { API_BASE_URL } from '../../constants';

export const apiError = {
    apiError: ['An unknown error occurred!'],
};
export const resetPasswordUrl = `${API_BASE_URL}/rest-auth/password/reset/confirm/`;
export const changePasswordUrl = `${API_BASE_URL}/rest-auth/password/change/`;
